import * as React from "react";
type Props = {
  className?: string,
};
function SvgDietary({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Dietary"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.475 23.7979C19.6315 14.1666 31.0821 -1.39455 16.2556 6.40012C-6.81732 18.5302 6.01039 28.3241 10.2141 32.1857C18.0784 39.41 47.3184 33.4293 33.475 23.7979Z"
        fill="#CCE0F4"
      />
      <path
        d="M19.812 8.40417C13.5654 8.40417 8.50171 13.4683 8.50171 19.7149C8.50171 25.9615 13.5658 31.0252 19.8124 31.0252C26.059 31.0252 31.1227 25.961 31.1227 19.7144C31.1156 13.4707 26.0557 8.41105 19.812 8.40417Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        d="M19.9302 29.1185C25.0586 29.1185 29.216 24.9611 29.216 19.8328C29.216 14.7044 25.0586 10.5471 19.9302 10.5471C14.8019 10.5471 10.6445 14.7044 10.6445 19.8328C10.6445 24.9611 14.8019 29.1185 19.9302 29.1185Z"
        stroke="currentColor"
      />
      <path
        d="M26.2004 15.9401L23.4224 18.718C23.1435 18.997 22.6912 18.997 22.4123 18.718L21.4021 17.7079C21.1232 17.4289 21.1232 16.9767 21.4021 16.6977L24.1801 13.9198M21.9072 18.2129L15.3845 24.7356M25.5059 15.2456L23.233 17.5185M24.8745 14.6143L22.6017 16.8871"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7993 15.2319C14.24 15.7884 14.4925 16.9479 15.3625 17.8212C16.2329 18.694 17.3912 18.9512 17.95 18.3942C18.5093 17.8377 18.2573 16.6778 17.3869 15.8049C16.5165 14.9321 15.3582 14.6749 14.7993 15.2319ZM24.3495 24.7879L17.9531 18.3915L24.3495 24.7879Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgDietary;
